<template>
  <component
    :is="tableComponent"
    ref="inner"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import UserTable from "./tables/UserTable.vue";
import ProfileTable from "./tables/ProfileTable.vue";
import CompanyTable from "./tables/CompanyTable.vue";
import DepartmentTable from "./tables/DepartmentTable.vue";
import RuleTable from "./tables/RuleTable.vue";
import AccessorialTable from "./tables/AccessorialTable.vue";
import CannedResponsesTable from "./tables/CannedResponsesTable.vue";
import CSPTable from "./tables/CSPTable.vue";
import BlackListTable from "./tables/BlackListTable.vue";

const TABLE_MAP = {
  User: UserTable,
  Profile: ProfileTable,
  Company: CompanyTable,
  Department: DepartmentTable,
  Rule: RuleTable,
  Accessorial: AccessorialTable,
  CannedResponses: CannedResponsesTable,
  CSP: CSPTable,
  BlackList: BlackListTable,
};

const FETCH_METHOD_MAP = {
  User: "getUsers",
  Profile: "getprofiles",
  Company: "getCompanies",
  Department: "getdepartments",
  Rule: "getAllRules",
  Accessorial: "updateInfoByType",
  CannedResponses: "getAllCannedResponses",
  CSP: "getAllCSP",
  BlackList: "getAllBlackList",
};

export default {
  name: "Table",
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      required: true,
      validator: (val) => Object.keys(TABLE_MAP).includes(val),
    },
  },
  computed: {
    tableComponent() {
      return TABLE_MAP[this.type] || null;
    },
    // Proxy reactivo: expone el término de búsqueda del componente interno
    searchField() {
      return this.$refs.inner?.searchField;
    },
  },
  methods: {
    // Proxy: delega cualquier llamada de método al componente especializado interno
    getUsers(...args) { return this.$refs.inner?.getUsers?.(...args); },
    getprofiles(...args) { return this.$refs.inner?.getprofiles?.(...args); },
    getCompanies(...args) { return this.$refs.inner?.getCompanies?.(...args); },
    getdepartments(...args) { return this.$refs.inner?.getdepartments?.(...args); },
    getAllRules(...args) { return this.$refs.inner?.getAllRules?.(...args); },
    updateInfoByType(...args) { return this.$refs.inner?.updateInfoByType?.(...args); },
    getAllCannedResponses(...args) { return this.$refs.inner?.getAllCannedResponses?.(...args); },
    getAllCSP(...args) { return this.$refs.inner?.getAllCSP?.(...args); },
    getAllBlackList(...args) { return this.$refs.inner?.getAllBlackList?.(...args); },
    getData(...args) {
      const fetchMethod = FETCH_METHOD_MAP[this.type];
      return this.$refs.inner?.[fetchMethod]?.(...args);
    },
  },
};
</script>
